var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98575 23.448L1.98576 18.8659L14.9933 26.5395L14.9933 30.9705L1.98575 23.448Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84788 17.5163L8.7252 15.3784L22.4951 23.3867L17.7481 25.126L4.84788 17.5163Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0445 15.1461L18.0384 13.0232L28.2209 18.7848L28.1122 23.3506L14.0445 15.1461Z",
    fill: "#3D3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3215 25.0573L21.5166 22.8106L14.9339 26.5395L14.9339 31.0001L25.3215 25.0573Z",
    fill: "#3D3D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0886 13.6391L15.4287 11.5011L8.10885 15.7046L12.4935 17.6614L19.0886 13.6391Z",
    fill: "#3D3D3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23926 7.50503L6.02749 5.39648V13.509L2.23926 15.5818V7.50503Z",
    fill: "#3D3D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2568 7.46914L24.4686 5.3606V13.4731L28.2568 15.5459V7.46914Z",
    fill: "#3D3D3D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02734 9.75659L6.02734 5.37418L15.2835 0.000119111L15.2835 4.25294L6.02734 9.75659Z",
    fill: "#3D3D3D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 9.75659L24.5332 5.37418L15.2771 0.000119111L15.2771 4.25294L24.5332 9.75659Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d85f1d4453b1a4a5e56e734a189f9f93.svg";
export { ForwardRef as ReactComponent };